import { Button } from "@repo/skapa";
import { t } from "@repo/translation";
import { ModalSheet, SearchSelect, SectionContainer } from "@repo/ui";
import { useState } from "react";

interface SelectionModalProps {
  isOpen: boolean;
  closeModal: () => void;
  title: string;
  allValues: [string, string][];
  selectedValues?: string[];
  onSelect: (values: string[]) => void;
  showSearch?: boolean;
  selectionMode: "SINGLE" | "MULTI";
}

export const SelectionModal = ({
  isOpen,
  closeModal,
  title,
  onSelect,
  allValues,
  selectedValues,
  showSearch = true,
  selectionMode,
}: SelectionModalProps) => {
  const [localSelected, setLocalSelected] = useState<string[]>(
    selectedValues ?? []
  );

  const onChange = (checked: boolean, item: { value: string | number }) => {
    if (selectionMode === "SINGLE") {
      setLocalSelected(checked ? [item.value as any] : []);
    } else if (selectionMode === "MULTI") {
      setLocalSelected(
        checked
          ? [...(localSelected ?? []), item.value as any]
          : (localSelected?.filter((el) => el !== item.value) ?? [])
      );
    }
  };

  return (
    <ModalSheet
      title={title}
      visible={isOpen}
      onClose={closeModal}
      onBack={closeModal}
      footer={
        <Button
          type="primary"
          onClick={() => {
            onSelect(localSelected);
            closeModal();
          }}
          text={t("action.save")}
        />
      }
    >
      <SectionContainer>
        <SearchSelect
          showSearch={showSearch}
          localState={localSelected}
          onChange={onChange}
          selectionMode={selectionMode}
          values={allValues}
        />
      </SectionContainer>
    </ModalSheet>
  );
};
